module.exports = __webpack_public_path__ + "img/case-market.1d974e00.png";